import {
  PAYOUT_AUTH_LOADING,
  PAYOUT_LOG_OUT,
  PAYOUT_SIGN_IN,
  PAYOUT_SIGN_IN_FAILED,
} from "../types";

const initialState = {
  loading: false,
  error: null,
  token: null,
  role: null,
  toUpdatePassword: null,
  id: null,
  message: null,
  userId: null,
  partnerId: null,
  pgId: null,
  refreshToken: null,
};

export const payoutAuthReducer = (
  state = initialState,
  action: {
    type: any;
    loading: any;
    payload: any;
    refreshToken: any;
    role: any;
    toUpdatePassword: any;
    error: any;
    id: any;
    userId: any;
    partnerId: any;
    pgId: any;
  }
) => {
  switch (action.type) {
    case PAYOUT_AUTH_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case PAYOUT_SIGN_IN:
      return {
        ...state,
        loading: false,
        token: action.payload.accessToken,
        refreshToken: action.refreshToken,
        role: action.role,
        toUpdatePassword: action.payload.toUpdatePassword,
        id: action.id,
        error: null,
        message: null,
        userId: action.userId,
        partnerId: action.partnerId,
        pgId: action.pgId,
      };

    case PAYOUT_SIGN_IN_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
        role: null,
        token: null,
        refreshToken: null,
        toUpdatePassword: null,
        message: null,
        id: null,
        userId: null,
        partnerId: null,
      };

    case PAYOUT_LOG_OUT:
      return {
        ...state,
        loading: false,
        error: null,
        role: null,
        token: null,
        toUpdatePassword: null,
        message: action.payload,
        id: null,
        userId: null,
        partnerId: null,
        refreshToken: null,
      };

    default:
      return state;
  }
};
